import { UserAdministratedBalances } from '../interfaces';
import { environment } from 'src/environments/environment';

/**
 * Delivery switch for the Edenred top-up flow.
 *
 * This is not an access control — the API is what decides who may recharge what. It exists so
 * the UI can ship ahead of the Edenred endpoints without offering the user a flow that cannot
 * complete: with it off, none of the Edenred screens, dialogs or requests are reachable.
 */
export function isEdenredRechargeActive(): boolean {
  return environment.edenredRechargeActive;
}

/** The wallet balances funded through the Edenred flow. */
const EDENRED_BALANCES: UserAdministratedBalances[] = [
  UserAdministratedBalances.EDENRED,
  UserAdministratedBalances.EDENRED_JUNAEB
];

export function isEdenredBalance(method: UserAdministratedBalances): boolean {
  return EDENRED_BALANCES.includes(method);
}

/**
 * Drops the Edenred products from a list of recharge methods while the flow is off.
 *
 * Applied wherever the recharge picker is fed, so a client whose backend still reports an
 * Edenred balance does not get an option that opens nothing.
 */
export function removeUnavailableEdenredMethods(
  methods: UserAdministratedBalances[]
): UserAdministratedBalances[] {
  if (isEdenredRechargeActive()) {
    return methods;
  }
  return methods.filter(method => !isEdenredBalance(method));
}
